export default __webpack_public_path__ + "static/solar-panel-e9e39e89fe173850e71c16b91b412f47.webp";